<template>
<section class="date-range">
  <el-date-picker
    v-model="query.beginTime"
    :picker-options="startDatePickerOptions"
    :clearable="false"
    :editable="false"
    placeholder="开始时间"
    type="month"
    format="yyyy年MM月"
    value-format="yyyy/MM/dd 00:00:00"
    size="small"
    style="width:140px;"
    @change="onBeginTimeChanged"
  />
  <span style="font-size:.7em;color:#606266"> ～ </span>
  <el-date-picker
    v-model="query.endTime"
    :picker-options="endDatePickerOptions"
    :clearable="false"
    :editable="false"
    placeholder="结束时间"
    type="month"
    format="yyyy年MM月"
    value-format="yyyy/MM/dd 23:59:59"
    size="small"
    style="width:140px;"
    @change="onEndTimeChanged"
  />
</section>
</template>

<script>
export default {
  name: 'CompareTimeMonth',
  props: {
    query: {
      required: true,
      type: Object
    }
  },
  computed: {
    startDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() > new Date(this.query.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() < new Date(this.query.beginTime)
      }
    }
  },
  methods: {
    setBeginTime () {
      let {query} = this
      query.beginTime = new Date(query.beginTime).format('yyyy/MM/01 00:00:00')
    },
    setEndTime () {
      let {query} = this
      let endTime = new Date(query.endTime)

      endTime.setDate(1)
      endTime.setMonth(endTime.getMonth() + 1)
      endTime.setDate(0)
      query.endTime = endTime.format('yyyy/MM/dd 23:59:59')
    },
    setQueryTimes () {
      let {query} = this
      let queryTimes = []
      let endTimeTS = new Date(query.endTime).getTime()

      for (let beginTime = new Date(query.beginTime); beginTime.getTime() <= endTimeTS; beginTime.setMonth(beginTime.getMonth() + 1)) {
        queryTimes.push(beginTime.format('yyyy年MM月'))
      }

      query.queryTimes = queryTimes
    },
    onBeginTimeChanged () {
      this.setBeginTime()
      this.setQueryTimes()
    },
    onEndTimeChanged () {
      this.setEndTime()
      this.setQueryTimes()
    }
  },
  created () {
    this.setBeginTime()
    this.setEndTime()
    this.setQueryTimes()
    this.$emit('select-changed', true)
  }
}
</script>

<style lang="scss" scoped>
.date-range {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Data/CompareTime/Month.vue